<fca-page [title]="title">
  <nav mat-tab-nav-bar [tabPanel]="tabPanel">
    <a
      *ngFor="let link of links"
      mat-tab-link
      [routerLink]="link.linkUrl"
      [active]="type === link.type"
    >
      {{ link.linkLabel }}
    </a>
  </nav>
  <ng-content></ng-content>
</fca-page>
